const template = document.querySelector('body');
const megaMenuHoverSwitchDelay = 120;

/********* Navigation *********/
const menusLvl2 = document.querySelectorAll('.mega-menu__submenu-lvl2');
menusLvl2.forEach((menuLvl2) => {
    // Init
    const menuLvl1 = menuLvl2.closest('details');
    const menuLvl2Item = menuLvl2.querySelector('li:first-child');
    let hoverSwitchTimer = null;

    const clearHoverSwitchTimer = () => {
        if (hoverSwitchTimer) {
            clearTimeout(hoverSwitchTimer);
            hoverSwitchTimer = null;
        }
    };

    loadMenu(menuLvl1, menuLvl2Item, '[data-ref]:first-child', ':first-child');
    menuLvl1.addEventListener('mouseleave', (e) => {
        clearHoverSwitchTimer();
        loadMenu(menuLvl1, menuLvl2Item, '[data-ref]:first-child', ':first-child');
    });

    // Hover Lvl2
    if (window.matchMedia('(min-width: 1024px)').matches) {
        const menuLvl2Items = menuLvl1.querySelectorAll('.mega-menu__submenu-lvl2 li');
        menuLvl2Items.forEach((menuLvl2Item) => {
            menuLvl2Item.addEventListener('mouseenter', () => {
                if (!menuLvl2Item.classList.contains('active')) {
                    clearHoverSwitchTimer();
                    hoverSwitchTimer = setTimeout(() => {
                        if (!menuLvl2Item.matches(':hover')) return;
                        const target = menuLvl2Item.getAttribute('data-ref');
                        loadMenu(menuLvl1, menuLvl2Item, '[data-ref="'+target+'"]', '#'+target);
                        hoverSwitchTimer = null;
                    }, megaMenuHoverSwitchDelay);
                }
            });

            menuLvl2Item.addEventListener('mouseleave', clearHoverSwitchTimer);
        });
    }
});
function loadMenu(menuLvl1, menuLvl2, menuLvl3Selector, pushSelector) {
    // Lvl2
    const menuLvl2Active = menuLvl1.querySelector('.mega-menu__submenu-lvl2 li.active');
    if (menuLvl2Active) {
        menuLvl2Active.classList.remove('active');
    }
    menuLvl2.classList.add('active');

    // Lvl3
    const menuLvl3Active = menuLvl1.querySelector('.mega-menu__submenu-lvl3 .active');
    if (menuLvl3Active) {
        menuLvl3Active.classList.remove('active');
    }
    const menuLvl3 = menuLvl1.querySelector('.mega-menu__submenu-lvl3 '+menuLvl3Selector);
    if (menuLvl3) {
        menuLvl3.classList.add('active');
    }

    // Push
    const pushActive = menuLvl1.querySelector('.mega-menu__promotions .active');
    if (pushActive) {
        pushActive.classList.remove('active');
    }
    const push = menuLvl1.querySelector('.mega-menu__promotions .push-wrapper'+pushSelector);
    if (push) {
        push.classList.add('active');
    }
}

/********* Show/Hide *********/
const showHideElements = document.querySelectorAll('.show-hide');
showHideElements.forEach((showHideElement) => {
    const showHideContent = showHideElement.querySelector('.show-hide-content');
    const showHideBtn = showHideElement.querySelector('.show-hide-btn');

    if (showHideContent && showHideBtn) {
        showHideBtn.addEventListener('click', () => {
            showHideElement.classList.toggle('active');

            if (showHideElement.classList.contains('active')) {
                showHideContent.style.maxHeight = showHideContent.scrollHeight + 'px';
            } else {
                showHideContent.style.maxHeight = '';
            }
        });
    }
});

/********* Product card *********/
function sliderCardProduct (productSliders) {
    productSliders.forEach((slider) => {
        // Destroy existing Swiper instance if it exists
        if (slider.swiper) {
            slider.swiper.destroy();
        }

        const sliderOptions = {
            modules: [window.FoxTheme.Swiper.Navigation, window.FoxTheme.Swiper.Pagination],
            slidesPerView: 1,
            spaceBetween: 20,
            pagination: {
                el: slider.querySelector('.swiper-pagination'),
                type: 'progressbar',
            },
            navigation: {
                nextEl: slider.querySelector('.swiper-btn-next'),
                prevEl: slider.querySelector('.swiper-btn-prev'),
            },
            loop: true,
        };

        const sliderInstance = new FoxTheme.Swiper.Swiper(slider, sliderOptions);
        sliderInstance.init();
    });
}
const productSliders = document.querySelectorAll('card-product-image-slider');
sliderCardProduct (productSliders);

setTimeout(()=> {
    const productSliders = document.querySelectorAll('product-slider card-product-image-slider');
    sliderCardProduct (productSliders);
}
,1000);

/********* Product *********/
if (template.classList.contains('product-template')) {
    function changeBadgeLocation() {
        const badgesContainer = document.querySelector('.product__block.product__block--badges');
        const badge = document.querySelector('.product-card__badge');
        const mediaWrapper = document.querySelector('.product__media-wrapper');
        const infoWrapper = document.querySelector('.product__info-wrapper');

        if (!badge || !badgesContainer || !mediaWrapper || !infoWrapper) return;

        if (window.matchMedia('(max-width: 767.98px)').matches) {
            mediaWrapper.appendChild(badge);
        } else {
            badgesContainer.appendChild(badge);
        }
    }

    changeBadgeLocation();
    window.addEventListener("resize", changeBadgeLocation);

    const loadMoreBtn = document.querySelector('.product__media-wrapper .btn[data-load-more]');
    if (loadMoreBtn) {
        const galleryWrapper = document.querySelector('.product__media-wrapper');
        loadMoreBtn.addEventListener('click', () => {
            galleryWrapper.classList.add('active');
        });
    }

    const galleryNav = document.querySelector('.product-gallery-nav');
    if (galleryNav) {
        const wrap = galleryNav.closest('.product__media-gallery-viewer-wrap');
        const swiperPrev = wrap && wrap.querySelector('.swiper-button-prev');
        const swiperNext = wrap && wrap.querySelector('.swiper-button-next');
        galleryNav.querySelector('.product-gallery-nav__prev').addEventListener('click', () => swiperPrev && swiperPrev.click());
        galleryNav.querySelector('.product-gallery-nav__next').addEventListener('click', () => swiperNext && swiperNext.click());
    }

    const popupTriggerProxies = document.querySelectorAll('[data-popup-trigger-source="previous"]');
    popupTriggerProxies.forEach((popupProxy) => {
        const triggerBlock = popupProxy.previousElementSibling;
        const popupButton = popupProxy.querySelector('[data-popup-trigger-button]');
        if (!triggerBlock || !popupButton) return;

        const openPopup = () => popupButton.click();
        triggerBlock.classList.add('cursor-pointer');
        if (!triggerBlock.hasAttribute('tabindex')) triggerBlock.setAttribute('tabindex', '0');
        if (!triggerBlock.hasAttribute('role')) triggerBlock.setAttribute('role', 'button');
        triggerBlock.setAttribute('aria-haspopup', 'dialog');

        const popupId = popupButton.getAttribute('aria-controls');
        if (popupId) triggerBlock.setAttribute('aria-controls', popupId);

        triggerBlock.addEventListener('click', openPopup);
        triggerBlock.addEventListener('keydown', (event) => {
            if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                openPopup();
            }
        });
    });
}

/********* Reinitialize product sliders on facet update *********/
FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.facetUpdate, () => {
    setTimeout(() => {
        const productSliders = document.querySelectorAll('card-product-image-slider');
        sliderCardProduct(productSliders);
    }, 100);
});
